import { useEffect } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/**
 * Re-creates the old `mil-up` reveal-on-scroll effect (previously driven by
 * gsap.min.js + ScrollTrigger.min.js loaded as <script> tags and re-run by
 * swup on every page swap).
 *
 * Call this once from Layout.jsx, passing the route pathname as `dep` so it
 * re-scans for `.mil-up` elements every time you navigate to a new page.
 */
export function useScrollReveal(dep) {
  useEffect(() => {
    // Wait one tick so the page's elements are actually in the DOM before
    // GSAP looks for them.
    const raf = requestAnimationFrame(() => {
      const els = gsap.utils.toArray('.mil-up')

      els.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 90%',
              toggleActions: 'play none none none',
            },
          }
        )
      })

      ScrollTrigger.refresh()
    })

    return () => {
      cancelAnimationFrame(raf)
      ScrollTrigger.getAll().forEach((t) => t.kill())
    }
  }, [dep])
}
